import React from 'react'
import "./GPMS_Pro_detail1.css"

function GPMS_Pro_detail1() {
  return (
    <>
      <div>
        <div className="gpms-ifile-hero">

          <video className="gpms-ifile-video" autoPlay loop muted playsInline>
            <source src="GPMS_img/GPMS_hero_section_video.mp4" type="video/mp4"/>
          </video>

          <div className="gpms-ifile-overlay">
            <h1 className='fw-bold text-center gpms-transforming'>
             Intelligent Port Operations Through Data
              <br />
              <span className='gpms-ai-color'>Vision & Predictive Analytics </span>
            </h1>

            <p className='gpms-gradient-col'>
              One Intelligent Platform | Complete Port Visibility | Smarter Decisions.
            </p>
          </div>

        </div>
      </div>
    </>
  )
}

export default GPMS_Pro_detail1;